export default angular.module("mars.vet.dnareports.controllers.faq",[]).controller('FaqsController',function($rootScope, $scope, $routeParams, $window, EntryService, EntryIDService, NavigationService) {
			'ngInject';
			EntryService.getEntry(EntryIDService.getEntryID('FAQs')).then(function(response) {
            var fields = response.fields;
            $rootScope.pageTitle = fields.title;
            $scope.breedQuestions = fields.breedQuestions;
            $scope.scienceQuestions = fields.scienceQuestions;
            $scope.faqsubtitle = fields.faqsubtitle;
            $scope.description = fields.description;
            $scope.OpenPopupWindow = function() {
                $window.open("http://www.aspsnippets.com/", "popup", "width=300,height=200,left=10,top=150");
            }
            NavigationService.setNavigationUrls();
            $window.ga('send', 'pageview', {
                'page': $rootScope.pageTitle
            });
			});
}).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/faq.controller.js